<template>
   <b-modal
      id="widget-setting-modal"
      size="lg"
      @shown="initializeModal()"
      title="Dashboard Widget Settings"
      header-close-label="Cancel"
      scrollable
    >
      <div class="modal-body">
        <b-row v-if="quoteClaim">
          <b-col cols="3">
            <b-form-checkbox v-model="formData.quote.visible">
              Quotes by Status
            </b-form-checkbox>
          </b-col>
          <b-col cols="3">
            <b-form-checkbox v-model="formData.quoteAmount.visible">
              Quotes Amount by Status
            </b-form-checkbox>
          </b-col>
          <b-col cols="3">
            <b-form-checkbox v-model="formData.quoteSalesPerson.visible">
              Quotes Sales by Sales Person
            </b-form-checkbox>
          </b-col>
          <b-col cols="3">
            <b-form-checkbox v-model="formData.quoteSalesByDate.visible">
              Quotes Sales by Date
            </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row v-if="salesOrderClaim">
          <b-col cols="3">
            <b-form-checkbox v-model="formData.salesOrder.visible">
              Sales Orders by Status
            </b-form-checkbox>
          </b-col>
          <b-col cols="3">
            <b-form-checkbox v-model="formData.salesOrderAmount.visible">
              Sales Order Amount by Status
            </b-form-checkbox>
          </b-col>
          <b-col cols="3">
            <b-form-checkbox v-model="formData.salesOrderSalesPerson.visible">
              Sales Order by Sales Person
            </b-form-checkbox>
          </b-col>
          <b-col cols="3">
            <b-form-checkbox v-model="formData.salesOrderSalesByDate.visible">
              Sales Order by Date
            </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row v-if="purchaseOrderClaim">
          <b-col cols="3">
            <b-form-checkbox v-model="formData.purchaseOrder.visible">
              Purchase Orders by Status
            </b-form-checkbox>
          </b-col>
          <b-col cols="3">
            <b-form-checkbox v-model="formData.purchaseOrderAmount.visible">
              Purchase Order Amount by Status
            </b-form-checkbox>
          </b-col>
          <b-col cols="3">
            <b-form-checkbox v-model="formData.purchaseOrderBalanceDue.visible">
              Purchase Orders Balance Due
            </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row v-if="invoiceClaim">
          <b-col cols="3">
            <b-form-checkbox v-model="formData.invoiceStatusCount.visible">
              Invoices by Status
            </b-form-checkbox>
          </b-col>
          <b-col cols="3">
            <b-form-checkbox v-model="formData.invoiceSalesAmount.visible">
              Invoices Amount by Status
            </b-form-checkbox>
          </b-col>
          <b-col cols="3">
            <b-form-checkbox v-model="formData.invoiceSalesBySalesPerson.visible">
              Invoices Sales by Sales Person
            </b-form-checkbox>
          </b-col>
          <b-col cols="3">
            <b-form-checkbox v-model="formData.invoiceBalanceDue.visible">
              Invoices Balance Due
            </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="3">
            <b-form-checkbox v-model="formData.needAuthorization.visible">
              Need Authorization Count
            </b-form-checkbox>
          </b-col>
          <b-col cols="3">
            <b-form-checkbox v-model="formData.carScarReport.visible">
              CAR/SCAR Report
            </b-form-checkbox>
          </b-col>
        </b-row>
      </div>
      <template v-slot:modal-footer>
        <b-button @click="$bvModal.hide('widget-setting-modal')">Close</b-button>
        <b-button variant="primary" @click="onSubmit" :disabled="processedSettings">
          <i v-if="processedSettings" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>
          Save
        </b-button>
      </template>
    </b-modal>
</template>
<script>
  import { mapActions, mapGetters } from 'vuex';
  import { GRID_ID } from '@/shared/constants';
  import { roleMixin } from '@/shared/helpers';
  import { defaultLayout } from '../constants';

  export default {
    name: 'WidgetSetting',
    data() {
      return {
        gridId: GRID_ID.DASHBOARD_WIDGET,
        processedSettings: false,
        formData: {
          quote: { visible: true },
          quoteAmount: { visible: true },
          quoteSalesPerson: { visible: true },
          quoteSalesByDate: { visible: true },
          salesOrder: { visible: true },
          salesOrderAmount: { visible: true },
          salesOrderSalesPerson: { visible: true },
          salesOrderSalesByDate: { visible: true },
          purchaseOrder: { visible: true },
          purchaseOrderAmount: { visible: true },
          purchaseOrderBalanceDue: { visible: true },
          invoiceStatusCount: { visible: true },
          invoiceSalesAmount: { visible: true },
          invoiceSalesBySalesPerson: { visible: true },
          invoiceBalanceDue: { visible: true },
          needAuthorization: { visible: true },
          carScarReport: { visible: true },
          default: { visible: true },
        },
        salesOrderClaim: roleMixin.methods.checkClaim(roleMixin.data().CAN_VIEW_ALL_SALES_ORDERS),
        quoteClaim: roleMixin.methods.checkClaim(roleMixin.data().CAN_VIEW_ALL_QUOTE),
        purchaseOrderClaim: roleMixin.methods.checkClaim(roleMixin.data().CAN_VIEW_ALL_POS),
        invoiceClaim: roleMixin.methods.checkClaim(roleMixin.data().CAN_VIEW_ALL_INVOICES),
        defaultData: defaultLayout,
      };
    },
    computed: {
      ...mapGetters('account', ['gridSettingsById']),
    },
    methods: {
      ...mapActions('account', ['saveGridSettings']),
      async saveLayout(isReset = true){
        try {
          this.processedSettings = true;
          if (isReset) {
            const deleteConfirmed = await this.openConfirmBox({message: 'Are you sure you want to reset layout?'});
            if (deleteConfirmed) {
              let myFormData = this.formData;
              Object.keys(this.formData).forEach(item => {
                myFormData = {...myFormData, [item]: {...myFormData[item], visible: true}};
              });
              this.formData = {...this.formData, ...myFormData};

              await this.saveGridSettings({
                id: this.gridId,
                settings: {layout: JSON.parse(JSON.stringify(defaultLayout)), name: this.formData},
              });
            }
          }
          this.processedSettings = false;
        }catch (e) {
          this.processedSettings = false;
          /*console.log(e.message);*/
        }
      },
      async onSubmit(e) {
        try {
          this.processedSettings = true;

          let currentSettings = await this.gridSettingsById(this.gridId);
          let currentLayouts = currentSettings.layout;

          //first hide updated records
          currentLayouts = await currentLayouts.map((item) => ({
            ...item,
            //if widget is currently visible and user want to hide then hide it.
            visible: (this.formData[item.group] !== undefined && !this.formData[item.group].visible) ? false : item.visible,
          }));

          //now find maximum y position from visible records of current layouts
          var maxY = Math.max(...currentLayouts.map(o => {
            return (o.visible && !o.x) ? parseInt(o.y + o.h) : 0;
          }));
          let myLayout = [];
          this.defaultData.forEach((item, index) => {
            //check this item exist in store
            let existRecord = currentLayouts.filter((layout) => item.name == layout.name);
            if (existRecord.length) {
              //if record current visible and new visible value are different then and only then make change
              if (existRecord[0].group !== undefined && item.group !== undefined && existRecord[0].group == item.group && this.formData[item.group] !== undefined && this.formData[item.group].visible && !existRecord[0].visible) {
                item.visible = this.formData[item.group].visible;
                item.x = 0;
                item.w = existRecord[0].w;
                item.h = existRecord[0].h;
                item.y = maxY;
                myLayout.push(item);
                maxY += existRecord[0].h;
              } else {
                myLayout.push(existRecord[0]);
              }
            } else if (this.formData[item.group] !== undefined && this.formData[item.group].visible) {
              //console.log('in not record ', index, item.group, this.formData[item.group].visible);
              //if this item adding first time then
              item.visible = this.formData[item.group].visible;
              item.x = 0;
              item.y = maxY;
              item.w = item.w;
              item.h = item.h;
              myLayout.push(item);
              maxY += existRecord[0].h;
              //console.log(item.y, item.h, maxY);
            } else {
              //console.log('in else ', index, item.group, this.formData[item.group]);
              myLayout.push({...item, x: 0, y: maxY});
            }
          });
          //console.log('myLayout',myLayout);
          if (myLayout.length) {
            /*myLayout.forEach((item) => {
            console.log('updatedLayout visible', item);
          });*/

            await this.saveGridSettings({
              id: this.gridId,
              settings: {layout: myLayout, name: this.formData},
            });
          }
          this.processedSettings = false;
          this.$bvModal.hide('widget-setting-modal');
        }catch (e) {
          this.processedSettings = false;
          /*console.log(e.message);*/
        }
      },
      async initializeModal(getData = false) {
        let currentSettings = await this.gridSettingsById(this.gridId);
        currentSettings = { ...currentSettings, name: (currentSettings.name) ? currentSettings.name : {} };
        let myFormData = this.formData;
        Object.keys(this.formData).forEach(item => {
          myFormData = { ...myFormData, [item]: { ...myFormData[item], ...currentSettings.name[item] } };
        });
        this.formData = { ...this.formData, ...myFormData };
      },
    },
    mounted() {
    },
  };
</script>
